import { render, staticRenderFns } from "./CreateNewDeliveryOrder.vue?vue&type=template&id=5b80c358&"
import script from "./CreateNewDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./CreateNewDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewDeliveryOrder.vue?vue&type=style&index=0&id=5b80c358&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports